export default "__VITE_ASSET__B$YgVcPW__"